'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ../~/axios/lib/cancel/isCancel.js
// module id = 147
// module chunks = 0